import { loadAppConfig } from "@/lib/config";
import type { AppEnv } from "@/lib/config/types";

export const useConfig = () => {
  const appEnv = import.meta.env.VITE_APP_ENV as AppEnv | "local";

  return loadAppConfig(appEnv ?? "development");
};
